import React, { createContext, useContext, useState, useEffect } from 'react';
import { api, errorMessage } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Kiểm tra token khi khởi động app
  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      setLoading(false);
      return;
    }

    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    const fetchUserInfo = async () => {
      try {
        const response = await api.get('/admin/auth/me');
        if (response.data.success) {
          setUser(response.data.data);
        } else {
          logout();
        }
      } catch (error) {
        console.error('Fetch user info error:', error);
        logout();
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, []);

  const login = async (email, password) => {
    try {
      const response = await api.post('/admin/auth/login', { email, password });
      
      if (response.data.success) {
        const { access_token: token, user: userData } = response.data.data;
        
        // Lưu token vào localStorage
        localStorage.setItem('admin_token', token);
        
        // Thêm token vào header của axios
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        // Cập nhật state
        setUser(userData);
        
        return { success: true, data: userData };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      const message = errorMessage(error, 'Đăng nhập thất bại');
      return { success: false, message };
    }
  };

  const logout = () => {
    // Xóa token khỏi localStorage
    localStorage.removeItem('admin_token');
    
    // Xóa token khỏi header của axios
    delete api.defaults.headers.common['Authorization'];
    
    // Reset user state
    setUser(null);
  };

  const value = {
    user,
    loading,
    login,
    logout,
    isAuthenticated: !!user,
    isAdmin: user?.role === 'ADMIN'
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
